import { render, staticRenderFns } from "./orderBase.vue?vue&type=template&id=f62cbcdc&scoped=true&"
import script from "./orderBase.vue?vue&type=script&lang=js&"
export * from "./orderBase.vue?vue&type=script&lang=js&"
import style0 from "./orderBase.vue?vue&type=style&index=0&id=f62cbcdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62cbcdc",
  null
  
)

export default component.exports